const getters = {
  loggedIn: (state) => state.loggedIn,
  token: (state) => state.token,
  modalSessions: (state) => state.modalSessions,
  modalUpgrade: (state) => state.modalUpgrade,
  basicModal: (state) => state.basicModal,
}

export default getters
